module.exports = __webpack_public_path__ + "img/USA.37364299.png";